import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { useFunnel } from '../../contexts/FunnelContext';
import { phones, brand } from '../../data/siteConfig';
export function FunnelHeader() {
  const {
    t
  } = useFunnel();
  return <header className="sticky top-0 z-30 border-b border-ink-700 bg-ink" data-id="element-447" data-mp="3oyg8meotmyk1">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-2 px-3 sm:px-6" data-id="element-448" data-mp="3k1psxsgxi4z5">
        <div className="flex min-w-0 items-center gap-1.5 sm:gap-2" aria-label={brand.name} data-id="element-449" data-mp="3fzmd6rn88e82">
          <span className="rounded bg-lime px-1.5 py-0.5 font-display text-sm font-black text-ink sm:text-lg" data-id="element-450" data-mp="3b001wnqyl81w">{brand.mark}</span>
          <span className="truncate whitespace-nowrap font-display text-sm font-black tracking-tight text-white min-[400px]:text-base sm:text-2xl" data-id="element-451" data-mp="361os2d0nyxjo">{brand.word}</span>
          <span className="hidden text-xs font-medium text-ink-300 xl:inline" data-id="element-452" data-mp="14a1yc3pe0oji">{t('brandSub')}</span>
        </div>
        <div className="flex shrink-0 items-center" data-id="element-453" data-mp="zbs3xvbhlryy">
          <a href={phones.ai.href} aria-label={`${t('callKyle')} ${phones.ai.display}`} className="flex h-10 items-center gap-2 rounded-lg bg-lime px-3 text-sm font-bold text-ink transition-[background-color] duration-150 ease-out hover:bg-white" data-id="element-454" data-mp="z8w0jrgveb34">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-455" data-mp="3btvgpn6se5k7" />
            <span className="hidden whitespace-nowrap sm:inline" data-id="element-456" data-mp="3gr3znpzredmi">{t('callKyle')}</span>
            <span className="whitespace-nowrap sm:hidden" data-id="element-457" data-mp="8btta5ou6m8x">{t('callShort')}</span>
          </a>
        </div>
      </div>
    </header>;
}